// Фото витрины, снятое без сети: блоб в IndexedDB до отправки (в localStorage
// снимок не поместится). Ключ — `${shiftId}:${pointId}`.

const DB = 'resstro-courier';
const STORE = 'photos';

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function run<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await open();
  try {
    return await new Promise<T>((resolve, reject) => {
      const req = fn(db.transaction(STORE, mode).objectStore(STORE));
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  } finally {
    db.close();
  }
}

export interface StoredPhoto {
  blob: Blob;
  name: string;
}

export const putPhoto = (key: string, photo: StoredPhoto) => run('readwrite', (s) => s.put(photo, key)).then(() => undefined);
export const getPhoto = (key: string) => run<StoredPhoto | undefined>('readonly', (s) => s.get(key) as IDBRequest<StoredPhoto | undefined>);
export const deletePhoto = (key: string) => run('readwrite', (s) => s.delete(key)).then(() => undefined);
